import { SidebarItemsProps } from './SidebarItems';

import { MultiLevelMenu } from './MultiLevel';
import { SingleLevelMenu } from './SingleLevel';

export const MenuItem = ({ item }: { item: SidebarItemsProps }) => {
  const Component = item.child?.length ? MultiLevelMenu : SingleLevelMenu;
  return <Component item={item} nested={false} />;
};
